// src/components/AIMito/queryIntent.ts
export type IntentType =
  | 'TAX_RETURNS'
  | 'TAX_EXTENSIONS'
  | 'PROJECTS'
  | 'BUSINESSES'
  | 'ACCOUNTANTS'
  | 'DOCUMENTS'
  | 'UPCOMING_DATES'
  | 'ANNOUNCEMENTS';

export interface Intent {
  type: IntentType;
  wantCountOnly: boolean; // ← “how many …” questions
}

const PATTERNS: Record<IntentType, RegExp> = {
  TAX_RETURNS: /(tax\s*(returns?)|questionnaires?)/i,
  TAX_EXTENSIONS: /(tax\s*extensions?)|extensions?/i,
  PROJECTS: /\bprojects?\b/i,
  BUSINESSES: /\b(business(es)?|compan(y|ies))\b/i,
  ACCOUNTANTS:
    /\b(accountant(s)?|assignee(s)?|advisor(s)?|team|schedule|meeting(s)?|appointment(s)?)\b/i,
  DOCUMENTS: /\b(document(s)?|file(s)?)\b/i,
  UPCOMING_DATES: /\b(?:upcoming|next)\s+(dates?|deadlines?)\b/i,
  ANNOUNCEMENTS: /\bannouncement(s)?\b/i,
};

export function getIntent(prompt: string): Intent | null {
  const lowered = prompt.toLowerCase();
  const found = (Object.keys(PATTERNS) as IntentType[]).find((t) =>
    PATTERNS[t].test(lowered),
  );
  if (!found) return null;

  return {
    type: found,
    wantCountOnly: /\bhow many\b|\bcount\b/.test(lowered),
  };
}
